import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Icon = ({ className = '', name, size = '1x', variant = 'solid' }) => {
  let v;
  switch (variant) {
    case 'brand':
      v = 'b';
      break;
    case 'duotone':
      v = 'd';
      break;
    case 'light':
      v = 'l';
      break;
    case 'regular':
      v = 'r';
      break;
    case 'solid':
      v = 's';
      break;
    default:
      v = 's';
      break;
  }
  return (
    <FontAwesomeIcon
      className={className}
      icon={[`fa${v}`, name]}
      size={size}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([
    'lg',
    'xs',
    'sm',
    '1x',
    '2x',
    '3x',
    '4x',
    '5x',
    '6x',
    '7x',
    '8x',
    '9x',
    '10x',
  ]),
  variant: PropTypes.oneOf(['brand', 'duotone', 'light', 'regular', 'solid']),
};

export default Icon;
